/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconExposureMinus1 = createReactComponent("exposure-minus-1", "IconExposureMinus1", [
  ["path", { d: "M3 12h6", key: "svg-0" }],
  ["path", { d: "M18 19v-14l-4 4", key: "svg-1" }]
]);

export { IconExposureMinus1 as default };
//# sourceMappingURL=IconExposureMinus1.js.map
